import { createSlice } from "@reduxjs/toolkit";
import { fynitoApi } from "../../../Components/Services/axios";
import toastify from "../../../helper/toastify";

const initialState = {
    wishlist: JSON.parse(localStorage.getItem("wishlist")) || [],
    restaurentist: JSON.parse(localStorage.getItem("restaurentist")) || [],
};

export const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        toggleWishlist: (state, action) => {
            const item = action.payload;
            const index = state.wishlist.findIndex((arr) => arr.id === item.id);
            if (index !== -1) {
                state.wishlist.splice(index, 1); // Remove item if it exists
            } else {
                state.wishlist.push(item); // Add item if not in wishlist
            }

            localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
        },
        setWishlist: (state, action) => {
            state.wishlist = action.payload;
            localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
        },
        toggleRestaurentWishlist: (state, action) => {
            const item = action.payload;
            const index = state.restaurentist.findIndex((arr) => arr.id === item.id);
            if (index !== -1) {
                state.restaurentist.splice(index, 1); // Remove item if it exists
            } else {
                state.restaurentist.push(item); // Add item if not in wishlist
            }

            localStorage.setItem("restaurentist", JSON.stringify(state.restaurentist));
        },
        setRestaurantWishlist: (state, action) => {
            state.restaurentist = action.payload;
            localStorage.setItem("restaurentist", JSON.stringify(state.restaurentist));
        },
    },
});

export const { toggleRestaurentWishlist, toggleWishlist, setWishlist, setRestaurantWishlist } = wishlistSlice.actions;

export const addFoodToFavourite = (payload) => async (dispatch) => {
    try {
        const res = await fynitoApi.post('/food-like', { menu_id: payload.id });
        if (res.data.status_code === 200) {
            dispatch(toggleWishlist(payload));
            toastify.success(res.data.message);
        } else {
            toastify.error(res.data.message)
        }
    } catch (error) {

    }
}

export const foodLikeList = () => async (dispatch) => {
    try {
        const res = await fynitoApi.get('/food-like-list');
        if (res.data.status_code === 200) {
            dispatch(setWishlist(res.data.data));
        } else {
            toastify.error(res.data.message)
        }
    } catch (error) {
    }
}

export const addFoodToFavouriteRestaurent = (payload) => async (dispatch) => {
    try {
        const res = await fynitoApi.post('/restaurant-like', { restaurant_id: payload.id, like: payload.like });
        if (res.data.status_code === 200) {
            dispatch(toggleRestaurentWishlist(payload));
            toastify.success(res.data.message);
        } else {
            toastify.error(res.data.message)
        }
    } catch (error) {

    }
}

export const restaurantLikeList = () => async (dispatch) => {
    try {
        const res = await fynitoApi.get('/restaurant-like-list');
        if (res.data.status_code === 200) {
            dispatch(setRestaurantWishlist(res.data.data));
        } else {
            toastify.error(res.data.message)
        }
    } catch (error) {
    }
}

export default wishlistSlice.reducer;
